import React, { useState, useEffect } from "react";
import LogoGreen from "../../img/Logo.png";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Register.module.css";
import { loggedUser } from "../../redux/userSlice";

function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (user.token) {
      navigate("/");
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // eslint-disable-next-line
  }, []);

  const getUser = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_PORT}/users`,
        method: "POST",
        data: {
          firstname,
          lastname,
          email,
          address,
          password,
          password2,
        },
      });
      dispatch(
        loggedUser({
          id: response.data.id,
          token: response.data.token,
          email: response.data.email,
          firstname: response.data.firstname,
          lastname: response.data.lastname,
          address: response.data.address,
        })
      );
      navigate("/");
    } catch (error) {
      setError(error.response.data.msg);
    }
  };

  return (
    <>
      <div
        className={
          styles.main + " d-flex flex-column justify-content-center px-4"
        }
      >
        <div className=" d-flex flex-column align-items-center">
          <img
            src={LogoGreen}
            alt="Paca"
            className={styles.logo + " mx-auto"}
          />
          <h2 className={styles.title}>Registrar un usuario</h2>
        </div>
        <div className="mt-2">
          <div className={styles.form + " bg-light px-4 shadow"}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                getUser();
              }}
            >
              <div className="mb-2">
                <label htmlFor="exampleInputEmail1" className="form-label mt-3">
                  Nombre
                </label>
                <input
                  value={firstname}
                  type="text"
                  name="name"
                  className="form-control"
                  onChange={(event) => {
                    setFirstname(event.target.value);
                    setError(null);
                  }}
                  required
                />
              </div>

              <div className="mb-2">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Apellido
                </label>
                <input
                  value={lastname}
                  type="text"
                  name="lastname"
                  className="form-control"
                  onChange={(event) => {
                    setLastname(event.target.value);
                    setError(null);
                  }}
                  required
                />
              </div>

              <div className="mb-2">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Email
                </label>
                <input
                  value={email}
                  type="email"
                  name="email"
                  className="form-control"
                  onChange={(event) => {
                    setEmail(event.target.value);
                    setError(null);
                  }}
                  required
                />
              </div>

              <div className="mb-2">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Dirección
                </label>
                {/* <div className="d-flex">
                  <select
                    className="rounded-2 border border-2 me-2"
                    name="type"
                    value={addressType}
                  >
                    <option selected></option>
                    <option value="1">Domicilio</option>
                    <option value="2">Trabajo</option>
                    <option value="3">Particular</option>
                  </select> */}
                <input
                  value={address}
                  type="text"
                  name="address"
                  className="form-control"
                  onChange={(event) => {
                    setAddress(event.target.value);
                    setError(null);
                  }}
                  required
                />
                {/* </div> */}
              </div>

              <div className="mb-2">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Contraseña
                </label>
                <input
                  required
                  value={password}
                  name="password"
                  type="password"
                  className="form-control"
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setError(null);
                  }}
                />
              </div>
              <div className="mb-2">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Repetir contraseña
                </label>
                <input
                  required
                  value={password2}
                  name="password2"
                  type="password"
                  className="form-control"
                  onChange={(event) => {
                    setPassword2(event.target.value);
                    setError(null);
                  }}
                />
              </div>
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    id="exampleCheck1"
                  />
                  <label className="form-check-label" htmlFor="exampleCheck1">
                    Recordarme
                  </label>
                </div>
                <Link to="/login" className={styles.linkForgetPassword}>
                  Tienes usuario? Login
                </Link>
              </div>
              <button type="submit" className={styles.btnLogin}>
                Registrarme
              </button>
              {error ? (
                <p style={{ color: "red", marginTop: "5px" }}>{error}</p>
              ) : (
                <></>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
